import { render, staticRenderFns } from "./MineInfo.vue?vue&type=template&id=485d0d1d&scoped=true"
import script from "./MineInfo.vue?vue&type=script&lang=js"
export * from "./MineInfo.vue?vue&type=script&lang=js"
import style0 from "./MineInfo.vue?vue&type=style&index=0&id=485d0d1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d0d1d",
  null
  
)

export default component.exports